require('../../modules/es6.string.includes');
module.exports = require('../../modules/_core').String.includes;



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/fn/string/includes.js